import React, { createRef } from "react";

import { Box, withStyles } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import { pluralizeText } from "@ip-utils";
import { Button, Dialog } from "@ip-widgets";

import Date from "./Date";
import Select from "./Select";

class Filter extends React.Component {
  constructor(props) {
    super(props);

    this.ref = createRef();

    const count = this.props.filters.reduce(
      (total, filter) => total + (filter.component.count || 1),
      0
    );

    this.state = {
      containerWidth: null,
      width: (150 + 16) * count + 32,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize);
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => {
    const { current } = this.ref;
    if (current) {
      const { compact, width } = this.state;

      const rect = current.parentNode.getBoundingClientRect();
      const compacted = rect.width - 216 < width;

      if (compact !== compacted) {
        this.setState({
          compact: compacted,
          containerWidth: compacted ? null : width,
        });
      }
    }
  };

  render() {
    const { classes, filtering, filters, rows, onChange, onReset } = this.props;
    const { compact, containerWidth } = this.state;

    const dialogButtonProps = {
      color: "secondary",
      label: `${filtering.length || ""} ${pluralizeText("Filter", filtering)}`,
      outlined: !filtering.length,
    };

    const items = filters.map(
      ({ columnName, component: Component, value }, key) => (
        <Component
          key={key}
          name={columnName}
          rows={rows}
          value={value}
          onChange={onChange}
        />
      )
    );

    return (
      <Box marginLeft={2} ref={this.ref} width={containerWidth}>
        {compact ? (
          <Dialog buttonProps={dialogButtonProps} title="Filters">
            <Dialog.Content>
              <Box className={classes.compact}>{items}</Box>
            </Dialog.Content>
            <Dialog.Actions>
              <Button
                color="secondary"
                disabled={!filtering.length}
                outlined
                onClick={onReset}
              >
                Reset
              </Button>
            </Dialog.Actions>
          </Dialog>
        ) : (
          <Box display="flex" alignItems="flex-end">
            <Box className={classes.expand}>{items}</Box>
            <Box ml={2}>
              <Button
                color="secondary"
                disabled={!filtering.length}
                icon={Clear}
                outlined
                size="small"
                tooltip="Reset Filters"
                onClick={onReset}
              />
            </Box>
          </Box>
        )}
      </Box>
    );
  }
}

Filter.Date = Date;
Filter.Select = Select;

const styles = (theme) => ({
  compact: {
    "& > *": {
      marginBottom: theme.spacing(2),
    },
  },
  expand: {
    display: "flex",
    flexGrow: 1,
    "& > *": {
      flex: 1,
    },
    "& > *:not(:first-child)": {
      marginLeft: theme.spacing(2),
    },
  },
});

export default withStyles(styles)(Filter);
